import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { defaultProps, propTypes } from './utils/project-shopping.util';
import { ProjectShoppingPlaceholder } from './ProjectShoppingPlaceholder';

const placeholder = (
  <ProjectShoppingPlaceholder />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return null;
  },
  client: () => {
    return import(
      /* webpackChunkName: "sps" */
      './ProjectShopping');
  },
  placeholder,
  name: 'ProjectShopping',
});

const HydratedComponent = withHydrator({
  id: 'project-shopping-section',
  placeholder,
  preserveCtxVal: 'clientStore',
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const ProjectShoppingImporter = withLayoutGroup({
  name: 'SPS'
}, DynamicComponent);

ProjectShoppingImporter.displayName = 'ProjectShoppingImporter';
ProjectShoppingImporter.propTypes = propTypes;
ProjectShoppingImporter.defaultProps = defaultProps;
